/**
 * Vuex module to sort SMS conversations
 */

import ChatLocalStorage from '@/api/chat'

const actions = {
  setProperty ({ commit }, property) {
    commit('SET_PROPERTY', property)
    ChatLocalStorage.setDmSortProperty(property)
    this.dispatch('chat/DmSortByFilter/sortDm')
  },
  setDirection ({ commit }, direction) {
    commit('SET_DIRECTION', direction)
    ChatLocalStorage.setDmSortDirection(direction)
    this.dispatch('chat/DmSortByFilter/sortDm')
  },
  sortDm () {
    this.dispatch('chat/getDirectMessages')
  },
  init ({ commit }) {
    commit('SET_PROPERTY', 'recent_activity')
    commit('SET_DIRECTION', ChatLocalStorage.dmSortDirection())
  }
}

const mutations = {
  SET_PROPERTY (state, property) {
    state.property = property
  },
  SET_DIRECTION (state, direction) {
    state.direction = direction
  }
}

const state = {
  directions: ['asc', 'desc'],
  property: 'recent_activity',
  direction: 'asc'
}

const getters = {
  directions: state => state.directions,
  property: state => state.property,
  direction: state => state.direction
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
